import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import React from 'react';
import ErrorBoundary from 'components/ErrorBoundary';
import ErrorScreen, { HANDLED_ERRORS } from './ErrorScreen';
function HubErrorBoundary(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    renderCustomError: function renderCustomError(error) {
      if ('status' in error && error.status === 404) {
        return /*#__PURE__*/React.createElement(ErrorScreen, {
          reason: "404"
        });
      } else if ('code' in error && typeof error.code === 'string' && HANDLED_ERRORS.includes(error.code)) {
        return /*#__PURE__*/React.createElement(ErrorScreen, {
          reason: error.code
        });
      }
    }
  }, children);
}
export default HubErrorBoundary;